import React, {useEffect, useState} from 'react'
import {
  IndemnityItems,
  IndemnityItemsInitValues as initialValues,
} from '..//indemnityItems-list//core///_models'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import InputMask from 'react-input-mask'
import axios from 'axios'
import {useLocation} from 'react-router-dom'
import Swal from 'sweetalert2'
import {MultiSelect} from 'primereact/multiselect'

import withReactContent from 'sweetalert2-react-content'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {Input3} from '../../../../../../components/Forms/Input'
import {deleteIndemnityItems, updateIndemnityItems} from '../indemnityItems-list/core/_requests'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../styles/styles'
import moment from 'moment'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'

//import {useToast} from '../../../../../../app/layout/hooks/toast'
const API_URL = process.env.REACT_APP_API_URL || 'api'
export interface UseOption {
  value: string
  label: string
  color?: string
  isFixed?: boolean
  isDisabled?: boolean
}

const IndemnityItemsSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  // issue_organ: Yup.number().required('Campo obrigatório'),
  // telephone: Yup.string().required('Campo obrigatório'),
  //descripton: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().required('Campo obrigatório'),
})

const FormIndemnityItemsEdit: React.FC = () => {
  const intl = useIntl()
  const location = useLocation()
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate()
  const [uuid, setUuid] = useState('')
  // eslint-disable-next-line
  const [selected, setSelected] = useState([])
  const {measurement_unit_id} = location.state as IndemnityItems
  const [selectedProjects, setSelectedProjects] = useState(null)
  const [projects, setProjects] = useState([])

  useEffect(() => {
    console.log('location', location)
    if (location) {
      const {uuid} = location.state as IndemnityItems
      setUuid(uuid || '')
      if (uuid) {
        getIndemnityItems(uuid)
        loadOptionsProject()
      }
    }
    // eslint-disable-next-line
  }, [location])

  async function getIndemnityItems(uuid: string) {
    // const {data} = getIndemnityItems(uuid)
    const {data} = await axios.get(API_URL + '/sgt/v1/indemnity_items/' + uuid)
    const IndemnityItems: IndemnityItems = data.data
    if (IndemnityItems.uuid) {
      formik.setFieldValue('uuid', IndemnityItems.uuid)
    }
    if (IndemnityItems.name) {
      formik.setFieldValue('name', IndemnityItems.name)
    }
    if (IndemnityItems.measurement_unit_id) {
      formik.setFieldValue('measurement_unit_id', IndemnityItems.measurement_unit_id)
    }
    if (IndemnityItems.reference_month) {
      formik.setFieldValue(
        'reference_month',
        IndemnityItems.reference_month
        // moment(IndemnityItems.reference_month).format('MMM  YYYY')
      )
    }
    if (IndemnityItems.direct_damage_value) {
      formik.setFieldValue(
        'direct_damage_value',
        (IndemnityItems.direct_damage_value || '').toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
      )
    }
    if (IndemnityItems.outgoing_profit_value) {
      formik.setFieldValue(
        'outgoing_profit_value',
        (IndemnityItems.outgoing_profit_value || '').toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
      )
    }
    if (IndemnityItems.single_payment_value) {
      formik.setFieldValue(
        'single_payment_value',
        (IndemnityItems.single_payment_value || '').toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
      )
    }
    if (IndemnityItems.projects) {
      setTimeout(() => {
        let projectsArray: any = []
        let projectsIdArray: any = []
        if (IndemnityItems.projects) {
          IndemnityItems.projects.map((project) => {
            projectsArray.push({
              code: project.id,
              name: `${project.code} - ${project.description}`,
            })
            projectsIdArray.push(project.id)
            return {projectsArray, projectsIdArray}
          })
        }
        formik.setFieldValue('project_id', projectsIdArray)
        setSelectedProjects(projectsArray)
      }, 3000)
    }
    return data
  }

  const [loading, setLoading] = useState(false)
  const formik = useFormik<IndemnityItems>({
    initialValues,
    validationSchema: IndemnityItemsSchema,
    onSubmit: async (values) => {
      if (values.reference_month) {
        values.reference_month = moment(values.reference_month).format('YYYY-MM')
      }
      console.log('teste', values)
      setLoading(true)
      try {
        //await axios.put(API_URL + '/v1/projects/' + values.uuid, values)
        await updateIndemnityItems(values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'INDEMNITY_ITEM.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/indemnityitem')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'INDEMNITY_ITEM.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  function resetInputs() {
    formik.resetForm()
  }

  async function deleteIndemnityItemsF(uuid: string) {
    deleteIndemnityItems(uuid)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'INDEMNITY_ITEM.SWAL_DELETE'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/indemnityItem')
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'INDEMNITY_ITEM.SWAL_DELETE_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
      })
  }

  function deleteMsgIndemnityItems() {
    MySwal.fire({
      title: intl.formatMessage({id: 'INDEMNITY_ITEM.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (uuid !== undefined) deleteIndemnityItemsF(uuid)
      }
    })
  }

  const loadOptions = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getUser()
      var units: any = []
      var options: any[] = []
      async function getUser() {
        const {data} = await axios.get(API_URL + '/v1/measurement_units/select2')
        let Response = data.results

        for (var i = 0; i < Response.length; i++) {
          const unit: UseOption = {
            value: Response[i].id,
            label: Response[i].abbreviation,
          }
          units.push(unit)
          if (measurement_unit_id === Response[i].id) {
            options.push(unit)
          }
        }
        setSelected(options[0])
      }

      callback(units)
    }, 1000)
  }

  const handleInputChange = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    setSelected(event)
    formik.setFieldValue(measurement_unit_id, inputValue)
    return {inputValue}
  }

  const loadOptionsProject = () => {
    setTimeout(() => {
      getProjects()
      let projects: any = []
      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const enterprise: any = {
              code: element.id,
              name: `${element.code} - ${element.description}`,
            }
            projects.push(enterprise)
          }
        }
      }
      setProjects(projects)
      return projects
    }, 1000)
  }
  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'INDEMNITY_ITEM.EDIT'})}</PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* INICIO LINHA 01*/}
            <div className='row mb-1'>
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                  placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                  {...formik.getFieldProps('name')}
                  required
                />
              </div>

              <div className='col-lg-6'>
                <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                  {intl.formatMessage({id: 'PROPERTIES.TITLE'})}
                </label>
                <InputMask
                  mask={'9999/99'}
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder={intl.formatMessage({id: 'INDEMNITY_ITEM.REFERECE_MONTH'})}
                  {...formik.getFieldProps('reference_month')}
                />
              </div>
            </div>
            {/* FIM LINHA 01 */}

            {/* INICIO LINHA 02 ------*/}
            <div className='row mb-1'>
              <div className='col-lg-6'>
                <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                  {intl.formatMessage({id: 'PRODUCTS.UNIT_MEASURE'})}
                </label>

                <AsyncSelect
                  className='form-control form-control-lg form-control-solid p-1 pl-1'
                  cacheOptions
                  loadOptions={loadOptions}
                  value={selected}
                  defaultOptions
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                  }
                  onChange={handleInputChange}
                  placeholder={intl.formatMessage({id: 'SELECT.INPUT_UNIT_MEASUREMENT'})}
                  styles={colourStyles}
                />
              </div>

              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'INDEMNITY_ITEM.DIRECT_DAMAGE_VALUE'})}
                  placeholder={intl.formatMessage({id: 'INDEMNITY_ITEM.DIRECT_DAMAGE_VALUE'})}
                  {...formik.getFieldProps('direct_damage_value')}
                />
              </div>
            </div>
            {/* FIM LINHA 02 */}

            {/* INICIO LINHA 03 ------*/}

            <div className='row mb-1'>
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'INDEMNITY_ITEM.OUTGOING_PROFIT_VALUE'})}
                  placeholder={intl.formatMessage({id: 'INDEMNITY_ITEM.OUTGOING_PROFIT_VALUE'})}
                  {...formik.getFieldProps('outgoing_profit_value')}
                />
              </div>
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'INDEMNITY_ITEM.SINGLE_PAYMENT_VALUE'})}
                  placeholder={intl.formatMessage({id: 'INDEMNITY_ITEM.SINGLE_PAYMENT_VALUE'})}
                  {...formik.getFieldProps('single_payment_value')}
                />
              </div>
            </div>
            {/* FIM LINHA 03 */}

            {/* INICIO EMPREEDIMENTO ----------------------*/}
            <div className='row mb-1'>
              <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'PROJECT.PROJECT_TITLE'})}
              </label>

              <div className='col-lg-12'>
                <MultiSelect
                  className='form-control form-control-lg form-control-solid p-1 pl-1 border border-white'
                  value={selectedProjects}
                  options={projects}
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '1.15rem',
                    fontWeight: 'medium',
                  }}
                  onChange={(e) => {
                    formik.setFieldValue(
                      'project_id',
                      e.value.map((v: any) => {
                        return v.code
                      })
                    )

                    setSelectedProjects(e.value)
                  }}
                  placeholder={intl.formatMessage({
                    id: 'MENU.PROJECTS',
                  })}
                  optionLabel='name'
                  filter
                  display='chip'
                />
              </div>
            </div>
            {/* FIM EMPREEDIMENTO ------------------------------*/}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.EDIT_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.EDITING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-secondary mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>

              <button
                type='button'
                onClick={deleteMsgIndemnityItems}
                className='btn btn-outline btn-outline-danger btn-active-danger ml-3'
              >
                {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormIndemnityItemsEdit}
